import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import {
  BrowserRouter as Router,
  Routes,
  Route,

} from "react-router-dom";
import Login from "./pages/auth/login/LoginPage";

// import ProfilePage from "./pages/ProfilePage";

import RoleReviewForm from "./pages/RoleReviewer/RoleReviewPage";
import { CssBaseline } from "@mui/material";

import ProtectedRoute from "./components/Common/ProtectedRoute";
import { privateRouteList } from "./route/route";
import Layout from "./components/Common/Layout";
import ForgotPasswordPage from "./pages/auth/forgotpassword/ForgotPasswordPage";
import VerifyCodePage from "./pages/auth/verifyCode/VerifyCodePage";
import ResetPasswordPage from "./pages/auth/resetPassword/ResetPasswordPage";
import CompleteRegistration from "./pages/manager/component/CompleteRegistration";
import ResendEmail from "./pages/manager/component/ResendEmail";

import ViewPage from "./pages/report/ViewPage";
// import ViewPage from "./pages/view/ViewPage";
const theme = createTheme({
  typography: {
    fontFamily: '"Jost", "Roboto", "Arial", sans-serif',
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Login route */}
          {/* <Route path="/register" element={<Register />} /> */}
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/verify-code" element={<VerifyCodePage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="complete-registration" element={<CompleteRegistration />} />
          <Route path="resend-email" element={<ResendEmail />} />
          <Route path="/user_details-stepss/:id" element={<RoleReviewForm />} />
          <Route path="/user_details-steps/" element={<RoleReviewForm />} />
          <Route path="/view" element={<ViewPage />} />
          {/* Protect profile route */}

          <Route element={<Layout />}>
            {privateRouteList.map((rest) => (
              <Route
                path={rest.path}
                element={
                  <React.Suspense>
                    <ProtectedRoute route={rest} />
                  </React.Suspense>
                }
              />
            ))}
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
